import { Autocomplete } from '@fullscreendigital/carrefour-dex-fe'
import { Input } from 'components/core-ui/Input'
import { formatUIDate } from 'utils/helpers'
import { statusOptions } from '../helpers'

export const getColumns = () => [
  {
    title: 'CIF',
    field: 'code',
    align: 'left',
    type: 'string',
    width: '150px'
  },
  {
    title: 'Name',
    field: 'name',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Country',
    field: 'country',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Type',
    field: 'legalEntityTypes',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '180px'
  },
  {
    title: 'Assignments',
    field: 'activeAssignmentsCount',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '180px'
  },
  {
    title: 'Stores',
    field: 'storesCount',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '100px'
  },
  {
    field: 'status',
    title: 'Status',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '100px',
    render: row => row.status?.name
  }
]

export const getFilters = (
  countryOptions: AutocompleteOption[],
  typesOptions: AutocompleteOption[]
) => {
  return [
    {
      name: 'legalEntityTypes.id',
      value: '',
      label: 'Type',
      type: 'autocomplete',
      filter: <Autocomplete variant="outlined" label="Type" options={typesOptions || []} />
    },
    {
      name: 'country.name',
      value: '',
      filter: <Autocomplete variant="outlined" label="Country" options={countryOptions || []} />,
      type: 'autocomplete',
      label: 'Country'
    },
    {
      name: 'isEnabled',
      value: '',
      filter: <Autocomplete variant="outlined" label="Status" options={statusOptions || []} />,
      type: 'autocomplete',
      label: 'Status'
    }
  ]
}
